import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "@/components/ui/sonner";
import { Lock, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.email) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#0A0A0A] text-white grain relative px-5">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full blob"
           style={{ background: "radial-gradient(circle, rgba(212,175,55,0.25), transparent 70%)" }} />
      <form onSubmit={submit} className="relative z-10 w-full max-w-md glass !bg-white/5 rounded-3xl p-8 sm:p-10 border border-white/10" data-testid="admin-login-form">
        <div className="flex flex-col items-center text-center mb-8">
          <span className="h-14 w-14 rounded-2xl bg-gold text-black grid place-items-center mb-5"><Lock size={24} /></span>
          <h1 className="font-display text-3xl font-bold">Kate Mercer CMS</h1>
          <p className="text-sm text-gray-400 mt-1">Admin sign in</p>
        </div>
        <label className="block text-xs uppercase tracking-wider text-gray-400 mb-2">Email</label>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email"
               className="w-full rounded-xl bg-white/10 border border-white/15 px-4 py-3 text-sm mb-5 focus:outline-none focus:border-gold" />
        <label className="block text-xs uppercase tracking-wider text-gray-400 mb-2">Password</label>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password"
               className="w-full rounded-xl bg-white/10 border border-white/15 px-4 py-3 text-sm mb-7 focus:outline-none focus:border-gold" />
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
                className="btn-gold w-full rounded-full py-3.5 text-sm font-semibold inline-flex items-center justify-center gap-2 disabled:opacity-70">
          {loading ? <Loader2 className="animate-spin" size={16} /> : "Sign In"}
        </button>
      </form>
    </div>
  );
}
